import { Component } from '@angular/core';

@Component({
  selector: 'mad-main-container',
  templateUrl: './main-container.component.html',
  styleUrls: ['./main-container.component.scss'],
  standalone: true,
})
export class MainContainerComponent {}
